import { useParams, useLocation } from 'react-router-dom'
import { useContext, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { APIContext } from 'context/APIContext'
import { useGetCoaches } from 'redux/customHooks/useGetCoaches'
import { useGetAthletes } from 'redux/customHooks/useGetAthletes'
import { setOrganizationAthletes, resetOrganizationGroups } from 'redux/slices/organization'

import ScreenFrame from 'components/Frame/ScreenFrame'
import KinesisProfileBreadCrumbs from 'components/Profile/KinesisProfileBreadCrumbs'
import GroupAthletesTab from 'components/Profile/GroupAthletesTab'

export default function GroupAthletesView() {

    const dispatch = useDispatch()

    const { urlGroupId } = useParams()
    const location = useLocation()

    const { GetGroupAthletes } = useContext(APIContext)

    const coaches = useGetCoaches()
    const athletes = useGetAthletes()

    const organizationId = useSelector(state => state.user.organizationId)    
    const trainingChartPresentWeekOfTheYearKey = useSelector(state => state.athleteProfile.trainingChartPresentWeekOfTheYearKey)

    const [groupAthletes, setGroupAthletes] = useState(null)

    const LoadGroupAthletes = async () => {
        setGroupAthletes(null)
        const groupAthletes = await GetGroupAthletes(urlGroupId)
        setGroupAthletes(groupAthletes)
    }

    const HandleGroupAthletesSaveSuccess = () => {
        dispatch(setOrganizationAthletes(null))
        dispatch(resetOrganizationGroups())
        LoadGroupAthletes()
    }

    useEffect(() => { LoadGroupAthletes() }, [urlGroupId])

    return (
        <ScreenFrame>
            <div className='max-w-4xl mx-auto space-y-4'>
                <KinesisProfileBreadCrumbs 
                    propProfileType='group' 
                    profileName={location.state?.profileName} 
                    currentPageName='Athletes' 
                />

                <div className='flex items-center gap-x-4 pb-1'>
                    <h1 className="text-2xl font-semibold text-gray-900 tracking-tight flex-grow">
                        Group Athletes
                    </h1>
                </div>

                <GroupAthletesTab
                    weekOfTheYearKey={trainingChartPresentWeekOfTheYearKey}
                    organizationId={organizationId}
                    coaches={coaches}
                    athletes={athletes}
                    groupId={urlGroupId != null ? parseInt(urlGroupId, 10) : null}
                    groupAthletes={groupAthletes}
                    OnSaveSuccess={HandleGroupAthletesSaveSuccess}
                />
            </div>
        </ScreenFrame>
    )
}